import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import FluxSpacesLanding from "./components/FluxSpacesLanding";
import Impressum from "./components/legal/Impressum";
import PrivacyPolicy from "./components/legal/PrivacyPolicy";
import Cookies from "./components/legal/Cookies";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (typeof window !== "undefined") {
      if ("scrollRestoration" in window.history) {
        window.history.scrollRestoration = "manual";
      }
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<FluxSpacesLanding />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<PrivacyPolicy />} />
          <Route path="/cookies" element={<Cookies />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
